import { useMemo } from 'react';

import { useCollectionServices } from 'hooks';
import services from 'services';
import { isAvailable } from 'utils';

const useOthersItems = () => {
  const items = useCollectionServices(services.appFrame.mobileNavigation.others);
  return useMemo(() => items.filter(({ available }) => isAvailable(available ?? true)), [items]);
};

export default useOthersItems;
